import { render, staticRenderFns } from "./search.vue?vue&type=template&id=56e49d67&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=56e49d67&prod&lang=scss"
import style1 from "./search.vue?vue&type=style&index=1&id=56e49d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e49d67",
  null
  
)

export default component.exports